import { useState, useEffect } from 'react'

import fetcher from '../services/fetcher'
import log from '../services/log'
import _ from '../services/comparators'

function useMetals(){
  const [metals, setMetals] = useState(null)

  useEffect(() => {
    const getMetals = async () => {
      const metals = await fetcher.getMetals()
      log.traceTag('metals', metals)
      setMetals(metals.sort(_.bySymbol))
    }

    getMetals();
  }, [])

  return metals;
}

export default useMetals;